import React from 'react';

import ModalBoxes from '../../../../../common/feedback/ModalBoxes/ModalBoxes';
import Button from '../../../../../common/general/Button';
import Icon from '../../../../../common/general/Icon';
import NotificationManager from '../../../../../common/notifications/NotificationManager';
import { INFORMED_CONSENT_ITEM_SAVE_FAILED } from '../../../../../constants/notificationMessages';
import { ADD_EDIT_INFORMED_CONSENT_ITEMS } from '../../../../../constants/userOperations';
import { userHasAccessTo } from '../../../../../services/auth';

import InformedConsentItemModal from './InformedConsentItemModal';

export default function InformedConsentItem({ label, current, id, studyId, updateItems }) {
  return (
    <div className="edit-informed-consent-setup-item">
      <p className="edit-informed-consent-setup-item-text">{current}</p>
      {userHasAccessTo(ADD_EDIT_INFORMED_CONSENT_ITEMS) && (
        <span className="edit-informed-consent-setup-item-button">
          <Button size="h28" priority="low" onClick={() => openEditModal({ label, current, id, studyId, updateItems })}>
            <Icon suit="glyphicon">edit</Icon>
          </Button>
        </span>
      )}
    </div>
  );
}

function openEditModal({ label, current, studyId, id, updateItems }) {
  ModalBoxes.open({
    component: (
      <InformedConsentItemModal label={label} id={id} current={current} studyId={studyId} updateItems={updateItems} />
    ),
    onClose: isChanged => {
      if (isChanged) {
        NotificationManager.error(INFORMED_CONSENT_ITEM_SAVE_FAILED);
      }
    }
  });
}
